import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AvailableEventItem from '../../components/available-events-item/AvailableEventsItem.component';
import useWindowSize from "../../hooks/useWindowSize";
import moment from "moment";
import { apiErrorHandler } from "../../utils/errorHandler";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import EventModalComponent from '../../components/available-events-item/EventModal.component.jsx';
import { getApiUrl } from "../../utils/apiUrls";
import instance from "../../utils/axios";
import { useSearchParams } from "react-router-dom";
import { segregateTasks } from "../../utils/helperFn";

const AvailableEventsTable = ({ availableEvents, t, getAvailableEvents, hasMore, pageNo, searchTerm }) => {
    const windowSize = useWindowSize();
    const [searchParams] = useSearchParams();
    const getRefId = searchParams.get('refId');

    const dispatch = useDispatch();

    const loadAvailableEvents = () => {
        return availableEvents.map((el, index) => <AvailableEventItem refId={getRefId} key={el.eventId} data={el} isMobile={windowSize.isMobile} eventHandler={eventHandler} />)
    }

    const [handleModal,handleModalChange] = React.useState({
        isOpen: false,
        data: null
      })

      const surveyDataHandler = (data) => {
        let temp = []
        let taskStatus = null
        if(!!data.selfLink){
          switch(data.seekerStatus){
            case "EXPIRED":
              taskStatus = "DID_NOT_PARTAKE";
              break;
            case "APPROVAL_COMPLETED":
              taskStatus = "COMPLETED";
              break;
            default:
              // YET_TO_START COMPLETED
              taskStatus = data.seekerStatus;

          }
          temp = [...temp,{...data,approverLink:null,nominationLink:null,taskStatus,name: t("provide_feedback") +"- " + data.name}]
        }
        if (!!data.nominationLink) {
          switch(data.seekerStatus){
            case "NOMINATION_COMPLETED":
            case "APPROVAL_PENDING":
            case "APPROVAL_COMPLETED":
              taskStatus = "COMPLETED";
              break;
            case "YET_TO_NOMINATE":
              taskStatus = "YET_TO_START";
              break;
            case "EXPIRED":
              taskStatus = "DID_NOT_PARTAKE";
              break;
            default:
              taskStatus = "";
          }
          temp = [
            ...temp,
            {
              ...data,
              approverLink: null,
              selfLink: null,
              taskStatus,
              taskTab: !data.nominationCompleted ? "YET_TO_START" : "COMPLETED",
              name: t("add_provider") + "- " + data.name,
            },
          ];
        }
        if (!!data.approverLink) {
          switch (data.approverStatus) {
            case "APPROVAL_PENDING":
              taskStatus = "YET_TO_START";
              break;
            case "APPROVAL_COMPLETED":
              taskStatus = "COMPLETED";
              break;
            case "EXPIRED":
              taskStatus = "DID_NOT_PARTAKE";
              break;
            default:
          }
          temp = [
            ...temp,
            {
              ...data,
              selfLink: null,
              nominationLink: null,
              taskStatus,
              taskTab: !data.approvalCompleted ? "YET_TO_START" : "COMPLETED",
              name: t("approve_providers") + "- " + data.name,
            },
          ];
        }
        return temp;
    }

    const eventHandler = async (eventId) => {
        try {
          const res = await instance.get(
            `${getApiUrl("getCandidateEventDetails")}?eventId=${eventId}`
          );
  
          if (!!res.data) {
            let candidateAllTaskList = [] 
            
            res.data.candidateGroupEventTaskDetailDTOList.forEach((el) => {
              if (el.taskType === "FEEDBACK_SURVEY") {
                const temp = surveyDataHandler(el);
                candidateAllTaskList = [...candidateAllTaskList, ...temp];
                return;
              }
              if (!el?.taskType && el.candidateTaskList.length > 0) {
                // TO MANAGE GROUP AND SEQUENCE FOR SURVEY
                let candidateTaskList = [];
                el.candidateTaskList.forEach((innerEl) => {
                  if (innerEl.taskType === "FEEDBACK_SURVEY") {
                    const temp = surveyDataHandler(innerEl);
                    candidateTaskList = [...candidateTaskList, ...temp];
                    return;
                }
                candidateTaskList.push(innerEl);
              });
               el.candidateTaskList = candidateTaskList;
              }
              candidateAllTaskList.push(el);
            });
            const {candidateTaskList, candidateCompletedTaskList, count} = segregateTasks(candidateAllTaskList);
            handleModalChange({
              data: {...res.data, candidateAllTaskList, candidateTaskList, candidateCompletedTaskList, count },
              isOpen: !handleModal.isOpen,
            });
          }
        } catch (error) {
          const errObj = apiErrorHandler(error);
          dispatch(
            openSnackBar({
              msg: t(errObj.statusText),
              type: "error",
            })
          );
        }
      };

    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [availableEvents]);

    const handleScroll = () => {
        //console.log('window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight', window.innerHeight + document.documentElement.scrollTop, document.documentElement.offsetHeight)
        if (window.innerHeight + document.documentElement.scrollTop <= document.documentElement.offsetHeight - 10) {
          return;
        }
        hasMore && getAvailableEvents(pageNo + 1)
      };

    return(
        <div className="cm-av-events-table-container">
            <div className="cm-av-events-table-header bg-blue-gray-50 d-none d-md-flex">
                <div className="col-sm-2">
                    <p className="text-blue-gray-700 my-0 cm-sm-txt fw-medium">{t("event_name")}</p>
                </div>
                <div className="col-sm-2 col-xl-2">
                    <p className="text-blue-gray-700 my-0 cm-sm-txt fw-medium">{t("event_status")}</p>
                </div>
                <div className="col-sm-2 col-xl-2">
                    <p className="text-blue-gray-700 my-0 cm-sm-txt fw-medium">{t("your_progress")}</p>
                </div>
                <div className="col-sm-3">
                    <p className="text-blue-gray-700 my-0 cm-sm-txt fw-medium">{t("event_timeline")}</p>
                </div>
                <div className="col-sm-2">
                    <p className="text-blue-gray-700 my-0 cm-sm-txt fw-medium">{t("event_hosted_by")}</p>
                </div>
                <div className="col-sm-1" />
            </div>
            <div className="cm-av-events-table-body bg-white">
                {
                    loadAvailableEvents()
                }

            </div>
            <EventModalComponent
                hasActionButton={true}
                t={t}
                handleModal={handleModal}
                eventTimeline={
                !!handleModal?.data?.startDate
                    ? `${moment(handleModal.data.startDate).format(
                        "MMM DD YYYY @ hh:mm A"
                    )} ${
                        !!handleModal.data.endDate &&
                        `- ${moment(handleModal.data.endDate).format(
                        "MMM DD YYYY @ hh:mm A"
                        )}`
                    }`
                    : ""
                }
                handleModalChange={handleModalChange}
            />
        </div>
    )
}

AvailableEventsTable.defaultProps = {
    availableEvents: []
}

export default AvailableEventsTable;